export default __webpack_public_path__ + "static/media/drone-red.31a438ae.png";